import { AnalyticsContext } from '@shared/core';
import React, { useEffect, useMemo, useContext, createContext } from 'react';

const ItemImpressionsTelemetryContext = createContext({
  setImpression: (_key: string) => {},
});

export function ItemImpressionsTelemetryProvider({ children }: { children: React.ReactNode }) {
  const { track } = useContext(AnalyticsContext);
  const impressions = new Set<string>();
  let defaultCount = 0;

  useEffect(() => {
    return () => {
      track({
        category: 'messaging.card',
        action: 'Items Impressed',
        extraInfo: {
          defaultCount,
          count: impressions.size,
        },
      });
    };
    // Purposely want to capture `impressions`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [track]);

  const value = useMemo(
    () => ({
      setImpression: (key: string) => {
        if (!impressions.size) {
          setTimeout(() => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultCount = impressions.size;
          }, 1000);
        }
        impressions.add(key);
      },
    }),
    // Purposely want to capture `impressions`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <ItemImpressionsTelemetryContext.Provider value={value}>{children}</ItemImpressionsTelemetryContext.Provider>;
}

export function useItemImpressionsTelemetry() {
  return useContext(ItemImpressionsTelemetryContext);
}
